export const modalDescriptions = {
  airport: {
    title: 'Que comprend notre service de transfert aéroport ?',
    subtitle: '✈️ Transfert aéroport',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Véhicule pour transfert aéroport',
    ariaLabel: {
      orderButton: 'Aller au formulaire de réservation du transfert aéroport',
      orderButtonText: 'Réserver un transfert',
      closeButton: 'Fermer la fenêtre modale',
    },
    list: [
      'Le chauffeur vous attendra avec une pancarte à la sortie du terminal.',
      'Assistance avec les bagages.',
      'Suivi du vol (nous savons si le vol est en retard).',
      'Jusqu’à 60 minutes d’attente gratuite.',
      'Véhicules haut de gamme (Wi-Fi, eau, siège enfant sur demande).',
      'Trajets disponibles depuis/vers l’aéroport Václav Havel.',
      'Tarifs à partir de 30 euros.',
    ],
    text: 'Notre service de transfert aéroport vous garantit un début ou une fin de voyage en toute sérénité. Nous suivons votre vol et vous accueillons avec une pancarte dans la zone d’arrivée. Le chauffeur vous aide avec les bagages et vous conduit confortablement, avec Wi-Fi, jusqu’à votre porte. La première heure d’attente est gratuite, aucun souci en cas de retard.',
  },

  corporate: {
    title: 'La solution idéale pour les entreprises',
    subtitle: '🧑‍💼 Transfert d’entreprise',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Véhicule business pour clients professionnels',
    ariaLabel: {
      orderButton:
        'Aller au formulaire de réservation du transfert d’entreprise',
      orderButtonText: 'Réserver un transfert',
      closeButton: 'Fermer la fenêtre modale',
    },
    list: [
      'Service dédié aux clients professionnels.',
      'Possibilité de signer un contrat avec votre entreprise.',
      'Facturation et rapport mensuel.',
      'Chauffeurs en costume, confidentialité assurée.',
      'Véhicules de catégorie business et plus.',
      'Réservation possible pour événements, conférences, délégations.',
      'Suivi de trajet via l’espace entreprise.',
    ],
    text: 'Nous proposons un service haut de gamme pour les entreprises exigeantes en matière de confort et de ponctualité. Nos chauffeurs professionnels assurent les trajets entre hôtels, centres de conférences et aéroports. Paiement mensuel sur facture possible. Vos collaborateurs seront conduits en toute sécurité et à l’heure.',
  },

  personal: {
    title: 'Votre chauffeur à la journée, à la semaine ou pour un voyage',
    subtitle: '🚗 Chauffeur personnel',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Chauffeur personnel avec voiture haut de gamme',
    ariaLabel: {
      orderButton:
        'Aller au formulaire de réservation d’un chauffeur personnel',
      orderButtonText: 'Réserver un chauffeur',
      closeButton: 'Fermer la fenêtre modale',
    },
    list: [
      'Location à l’heure ou à la journée.',
      'Déplacements, arrêts et attente inclus.',
      'Voiture haut de gamme avec chauffeur.',
      'Déplacements privés, shopping, rendez-vous importants.',
      'Idéal pour touristes, clients VIP, personnes âgées.',
      'Chauffeurs parlant anglais et tchèque.',
    ],
    text: 'Louer un chauffeur personnel est la solution idéale pour se déplacer librement et confortablement, sans contraintes. Votre chauffeur vous accompagnera tout au long du trajet, quelle que soit la complexité. Parfait pour vos achats, vos rendez-vous ou vos escapades. Voiture premium, service discret et confort inclus.',
  },

  vip: {
    title: 'Luxe et confort haut de gamme',
    subtitle: '👑 Services VIP et de luxe',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Véhicule VIP prêt pour le trajet',
    ariaLabel: {
      orderButton: 'Aller au formulaire de réservation d’un service VIP',
      orderButtonText: 'Réserver un transfert VIP',
      closeButton: 'Fermer la fenêtre modale',
    },
    list: [
      'Approche personnalisée pour chaque client.',
      'Véhicules de très haute gamme.',
      'Chauffeurs en costume avec expérience VIP.',
      'Confidentialité totale.',
      'Options supplémentaires : kit de bienvenue, eau minérale, journaux.',
      'Idéal pour réunions d’affaires, visites diplomatiques, mariages, événements.',
      'Assistance 24h/24 et gestionnaire personnel.',
    ],
    text: 'Louer un chauffeur personnel est la solution idéale pour se déplacer librement et confortablement, sans contraintes. Votre chauffeur vous accompagnera tout au long du trajet, quelle que soit la complexité. Parfait pour vos achats, vos rendez-vous ou vos escapades. Voiture premium, service discret et confort inclus.',
  },

  tours: {
    title: 'Voyagez avec confort et plaisir',
    subtitle: '🌍 Tours et excursions',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Véhicule pour excursions en Europe',
    ariaLabel: {
      orderButton: 'Aller au formulaire de réservation pour tour ou excursion',
      orderButtonText: 'Réserver un tour',
      closeButton: 'Fermer la fenêtre modale',
    },
    list: [
      'Organisation de tours individuels et en groupe.',
      'Guide ou chauffeur uniquement au choix.',
      'Itinéraires flexibles en Tchéquie et en Europe (Karlovy Vary, Vienne, Dresde, Munich, etc.).',
      'Voitures confortables, climatisation, Wi-Fi, eau potable.',
      'Arrêts photo, shopping, repas dans des restaurants locaux.',
      'Assurance voyage et assistance pendant le trajet.',
      'Réservation via formulaire en ligne possible.',
    ],
    text: 'Découvrez l’Europe avec nous — sans stress ni tracas. Nous organisons des excursions sur mesure ou en groupe selon vos envies. Avec guide ou simplement un chauffeur professionnel, profitez d’un voyage confortable. Chaque itinéraire est conçu pour la sécurité, le confort et des souvenirs inoubliables.',
  },
};
